import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CAMPAIGN_FORM_VALUES } from '../../pages/private/Campaign/forms/schema';
import { CAMPAIGNS_KEY } from '../../utils/constants';
import Api from '../Api';
import useApiStore from '../../store/useApiStore';
import { toastSuccess } from '../../components/partials/Toast/Toast';

interface PAYLOAD extends Omit<CAMPAIGN_FORM_VALUES, 'stateOrProvince' | 'city' | 'radiusInMiles' | 'standardStatus' | 'mlsSource'> {
  campaignSearchQuery: {
    listingContractDateFrom?: string;
    listingContractDateTo?: string;
    listingContractDateGreaterThanDays?: number;
    listingContractDateLessThanDays?: number;
    listPriceFrom?: number;
    listPriceTo?: number;
    yearBuiltFrom?: number;
    yearBuiltTo?: number;
    city: string;
    stateOrProvince: string;
    radiusInMiles: number;
  };
}

export default function useCreateCampaign() {
  const { onError } = useApiStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: PAYLOAD) => {
      const api = new Api({ onError });

      const data = await api.post({
        url: 'api/v1/campaigns',
        payload: { ...payload, zoneId: Intl.DateTimeFormat().resolvedOptions().timeZone },
      });

      return data;
    },
    onSuccess: () => {
      toastSuccess('Successfully created campaign.');

      queryClient.invalidateQueries({ queryKey: [CAMPAIGNS_KEY] });
    },
  });
}
